module.exports = __webpack_public_path__ + "static/Maya-00629fa0fc9a2883f5c5d722ec1c623d.png";